/*----------------------
   CARDS SLIDER
---------------------- */

cardsSlider = {
    init: function () {
        new Swiper('.swiper--cards-slider', {
            slidesPerView: "auto",
            mousewheel: {
                invert: false,
                forceToAxis: true
            },
            navigation: {
                nextEl: '.section-cards-slider .btn--next',
                prevEl: '.section-cards-slider .btn--prev',
            },
        });
    }
};


$(function () {
    cardsSlider.init();
});